import { CAMPGAIN_ID_QUERY_PARAM } from '@/shared/lib/store/constants';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { isCampaignId, useCampaignStore } from './campaignStore';

export const useSetCampaignId = () => {
	const { setCampaignId } = useCampaignStore();

	useEffect(() => {
		const url = new URL(window.location.href);
		const params = url.searchParams;

		const campaignIdParam = params.get(CAMPGAIN_ID_QUERY_PARAM);
		const campaignIdCookies = Cookies.get(CAMPGAIN_ID_QUERY_PARAM);

		if (campaignIdParam && isCampaignId(campaignIdParam)) {
			Cookies.set(CAMPGAIN_ID_QUERY_PARAM, campaignIdParam, { expires: 3 });
			setCampaignId(campaignIdParam);
		} else if (campaignIdCookies && isCampaignId(campaignIdCookies)) {
			setCampaignId(campaignIdCookies);
		}
	}, []);
};
